<!--非继教页面-->
<template>
  <div v-loading="loading" class="nup_main" element-loading-text="拼命加载中">
    <learnCardBind :value.sync="showLearnCardBind"></learnCardBind>
    <!--无数据-->
    <div v-if="projCourseList&&projCourseList.length==0" class="new_user_project_noSource">
      此培训班为考试类项目，请点击上方“我的练习”或“我的考试”完成您的培训。<br/>如需咨询请拨打客服电话：<span>400-822-2055</span>
    </div>
    <div v-else class="nupm_rightAll">
      <span style="position: absolute;display:block;line-height: 36px;color:#FF0000; font-size: 14px;left:190px;top:0;">{{ dueToRemind }}</span>
      <div class="nupmr_title">
        <a class="new_myCourse_sel" href="javascript:">我的课程</a>
      </div>
      <div class="nupmr_main">
        <div class="nupmrm_case">
          <div class="npm_caseDiv1" style="height: auto;padding-top: 6px;padding-bottom: 10px;padding-left:0px;">
            <span style="color:red">{{ currentTraining.trainingNotice }}</span>
          </div>
          <div v-if="currentTraining.learnState&&(currentTraining.learnState.compulsoryHourSetting!=0 || currentTraining.learnState.electivesHourSetting!=0)"
            class="npm_caseDiv1"
            style="height: auto;padding-top: 6px;padding-bottom: 10px;">
            <div class="npm_caseDiv1_left">学习进度：</div>
            <div class="npm_caseDiv1_right">
              <el-progress v-if="currentTraining.learnState.compulsoryHourSetting!=0" :percentage="parseInt(currentTraining.learnState.compulsoryProgress)"
                :stroke-width="16"
                :text-inside="true"
                style="width:450px;display: inline-block; "></el-progress>
              <!--判断是否显示学时-->
              <span v-if="currentTraining.hourShow==0 && currentTraining.learnState.compulsoryHourSetting!=0 && currentTraining.learnState.compulsoryProgress !=100"
                class="npm_caseDiv1_right_info">(已完成<strong> {{ currentTraining.learnState.compulsoryHour }} </strong>学时，需完成必修课程<strong> {{ currentTraining.learnState.compulsoryHourSetting }} </strong>学时)</span>
            </div>
            <div class="npm_caseDiv1_right">
              <el-progress v-if="currentTraining.learnState.electivesHourSetting!=0" :percentage="parseInt(currentTraining.learnState.electivesProgress)"
                :stroke-width="16"
                :text-inside="true"
                style="width:450px;display: inline-block; "></el-progress>
              <!--判断是否显示学时并且是否有选修学时-->
              <span v-if="currentTraining.hourShow==0 && currentTraining.learnState.electivesHourSetting!=0"
                class="npm_caseDiv1_right_info">(已完成<strong> {{ currentTraining.learnState.electivesHour }} </strong>学时，需完成选修课程<strong> {{ currentTraining.learnState.electivesHourSetting }} </strong>学时)</span>
            </div>
          </div>
          <div class="npm_caseDiv1">
            <div class="npm_caseDiv1_left">课程状态：</div>
            <div class="npm_caseDiv1_right">
              <!--<el-radio-group v-model="queryParam.courseState">
                <el-radio label="">全部</el-radio>
                <el-radio :label="0">未学习</el-radio>
                <el-radio :label="1">学习中</el-radio>
                <el-radio :label="2">已学完</el-radio>
              </el-radio-group>-->
              <label :class="{ 'new_radio_sel' : queryParam.courseState=='' }"><input v-model="queryParam.courseState" name="projState"
                type="radio" value=""/>全部</label>
              <label :class="{ 'new_radio_sel' : queryParam.courseState=='0'  }"><input v-model="queryParam.courseState" name="projState"
                type="radio" value="0"/>未学习</label>
              <label :class="{ 'new_radio_sel' : queryParam.courseState=='1'  }"><input v-model="queryParam.courseState" name="projState"
                type="radio" value="1"/>学习中</label>
              <label :class="{ 'new_radio_sel' : queryParam.courseState=='2'  }"><input v-model="queryParam.courseState" name="projState"
                type="radio" value="2"/>已学完</label>
            </div>
          </div>
          <div class="npm_caseDiv9">
            <div class="npm_caseDiv9_left">课程性质：</div>
            <div class="npm_caseDiv9_right">
              <ul class="i_nav-012">
                <el-radio-group v-model="queryParam.compulsory" size="small">
                  <el-radio-button label="">全部</el-radio-button>
                  <el-radio-button label="1">必修</el-radio-button>
                  <el-radio-button label="0">选修</el-radio-button>
                </el-radio-group>
              </ul>
              <input id="teacherOrCourseName" v-model="queryParam.keyword" placeholder="课程名称/主讲人" type="text"/>
              <input type="button" value="搜索" @click="search"/>
              <div class="npm_xflx_sqxf">
                <!--根据培训班设置是否有学分、学分申请方式、学分申请条件、绑定学习卡条件而定-->
                <template v-if="currentTraining.creditHave=='0' && currentTraining.creditApplyType==0">
                  <a v-if="currentTraining.learnState.trainingStatus==2 && currentTraining.learnState.applyCredit==false" v-show="applyScoreShow"
                    class="small_abtn jjmx_btn_sqxf1"
                    href="javascript:"
                    @click="applyScore(currentTraining.id,currentTraining.creditTypeName,currentTraining.creditValue)">申请学分</a>
                  <a v-else-if="currentTraining.learnState.trainingStatus==3 && currentTraining.learnState.applyCredit==false" class="small_abtn" href="javascript:"
                    style="background-color: #999999;">已申请学分</a>
                  <a v-else-if="currentTraining.learnState.applyCredit==true" class="small_abtn" href="javascript:"
                    style="background-color: #999999;">已授予学分</a>
                  <el-tooltip v-else class="item" content="未完成学习，不可申请学分" effect="dark" placement="right">
                    <a id="grayBut" class="small_abtn " href="javascript:"
                      style="background-color: #999999;">申请学分</a>
                  </el-tooltip>
                </template>
                <!--判断是否有学分并且学分是否显示-->
                <b
                  v-if="currentTraining.creditHave=='0' && currentTraining.creditShow==0">{{ currentTraining.projectTypeName }}
                  {{ currentTraining.creditTypeName }} {{ currentTraining.creditValue }}分</b>
              </div>
            </div>
          </div>
        </div>
        
        <div class="nupmrm_content">
          <el-collapse v-if="projCourseList && projCourseList.length>0" v-model="activeNames">
            <el-collapse-item v-for="(item,index) in projCourseList" :key="item.id" :name="index+1">
              <template slot="title">
                {{ item.projectName }}<span v-if="currentTraining.hourShow==0" style="float: right;margin-right: 30%"><b
                style="color:#38BCD5">{{ item.totalHour }}</b>学时</span>
              </template>
              <table class="collapse ba br2 b--black-10 pv1 ph1 w-100" style="text-align: center">
                <tbody>
                <tr class="striped--near-white">
                  <th class="pv1 ph3 tl f6 fw6 ttu" style="text-align: center">序号</th>
                  <th class="f6 ttu fw6 pv1 ph1" width="40%">课程名称</th>
                  <th class="f6 ttu fw6 pv1 ph1">课程性质</th>
                  <th v-if="currentTraining.hourShow==0" class="f6 ttu fw6 pv1 ph1">学时</th>
                  <th class="f6 ttu fw6 pv1 ph1">主讲人</th>
                  <th class="f6 ttu fw6 pv1 ph1">课程状态</th>
                  <th class="f6 ttu fw6 pv1 ph0" colspan="3">操作</th>
                </tr>
                <tr v-for="(childItem,index) in item.courseList" class="striped--near-white">
                  <td class="pv1 ph0" style="text-align: center">{{ index + 1 }}</td>
                  <td class="pv1 ph1" style="text-align: left;">
                    <el-tooltip :content="childItem.name" class="item" effect="dark" placement="top-start">
                      <a v-if="childItem.courseVideoNull"
                        :title="childItem.name"
                        class="course_name overflow"
                        href="javascript:"
                        style="max-width: 470px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;display: block">{{ childItem.name }}</a>
                      <a v-else
                        :title="childItem.name"
                        class="course_name overflow"
                        href="javascript:"
                        style="max-width: 470px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;display: block"
                        @click="openVideoware(childItem,item.id)">{{ childItem.name }}</a>
                    </el-tooltip>
                  </td>
                  <td class="pv1 ph1">{{ childItem.ybsProjectCourse.compulsory == 1 ? '必修' : '选修' }}</td>
                  <td v-if="currentTraining.hourShow==0" class="pv1 ph1">{{ childItem.ybsProjectCourse.classHour }}
                  </td>
                  <td class="pv1 ph1">{{ childItem.ybsRbacUser.nickName }}</td>
                  <td class="pv1 ph1">{{ courseStateComputed(childItem.ybsCourseState) }}</td>
                  <td class="pv1 ph0">
                    <a v-if="childItem.courseVideoNull" class="k1-1"
                      href="javascript:" style="padding-right: 0px;">视频[无]</a>
                    <a v-else class="k1"
                      href="javascript:"
                      style="padding-right: 0px;" @click="openVideoware(childItem,item.id)">视频</a>
                  </td>
                  <td class="pv1 ph0">
                    <a v-if="childItem.practiceNull" class="k3-3" href="javascript:"
                      style="padding-right: 0px;">练习[无]</a>
                    <a v-else class="k3" href="javascript:"
                      style="padding-right: 0px;"
                      @click="haveBandedLearningCard(item.id,childItem.id,childItem.courseFieldID,childItem.name)">
                      练习[{{ childItem.ybsCourseState && typeof childItem.ybsCourseState.practiseScore != 'undefined' && childItem.ybsCourseState.practiseScore != null ? '最高' + childItem.ybsCourseState.practiseScore + '分' : '未练' }}]
                    </a>
                  </td>
                  <td class="pv1 ph0">
                    <a v-if="childItem.handoutNull" class="k2-2" href="javascript:"
                      style="padding-right: 0px;">讲义[无]</a>
                    <a v-else class="k2" href="javascript:"
                      style="padding-right: 0px;" @click="openCourseware(currentTraining.id,item.id,childItem.id)">讲义</a>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-if="item.courseList.length==0" style="border: 1px ridge;text-align: center">暂无相关课程</div>
            </el-collapse-item>
          </el-collapse>
          <p v-else style="width:100%;text-align: center">没有找到符合要求的课程;若有疑问请拨打客服电话：<span>400-822-2055</span>
          </p>
          <el-collapse v-if="currentTraining.trainingType==106100 && studyTrainingThinking">
            <el-collapse-item>
              <template slot="title">
                住院医师规范化培训临床思维训练
              </template>
              <table class="collapse ba br2 b--black-10 pv2 ph3 w-100">
                <tbody>
                <tr class="striped--near-white">
                  <th class="pv2 ph3 tl f6 fw6 ttu">序号</th>
                  <th class="f6 ttu fw6 pv2 ph3">课程名称</th>
                  <th class="f6 ttu fw6 pv2 ph3">课程性质</th>
                  <th class="f6 ttu fw6 pv2 ph3">主讲人</th>
                  <th class="f6 ttu fw6 pv2 ph3">操作</th>
                </tr>
                <tr class="striped--near-white">
                  <td class="pv2 ph3">1</td>
                  <td class="pv2 ph3">
                    <el-tooltip :content="'住院医师规范化培训临床思维训练'" class="item" effect="dark"
                      placement="top-start">
                      <a :title="'住院医师规范化培训临床思维训练'"
                        class="course_name overflow"
                        href="javascript:"
                        onclick="">住院医师规范化培训临床思维训练</a>
                    </el-tooltip>
                  </td>
                  <td class="pv2 ph3">选修</td>
                  <td class="pv2 ph3">医博士</td>
                  <td class="pv2 ph3">
                    <a
                      :href="thinkingPractiseUrl+'?userid='+userInfo.id"
                      target="_blank">开始训练</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </el-collapse-item>
          </el-collapse>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import { applyCredit, getUserThinking, getUserTrainingExam, listStudentProjCourseInfoAndStatus } from '../api/api'
import { mapGetters } from 'vuex'
import jsonp from 'jsonp'

import learnCardBind from '../components/LearnCardBind'

export default {
  components: {
    learnCardBind
  },
  props: {
    currentTraining: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      applyScoreShow: true,
      loading: false,
      thinkingPractiseUrl: process.env.THINKING_PRACTISE_URL,
      queryParam: {
        courseState: '',
        compulsory: '',
        keyword: ''
      },
      studyTrainingThinking: false,
      activeNames: [1],
      projCourseList: null,
      dueToRemind: '',
      showLearnCardBind: false,
      readOnly: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    
    search() {
      this.loading = true
      if (!(this.$moment()).isBefore(this.$moment(this.currentTraining.endTime))) {
        this.readOnly = true
        this.dueToRemind = '提醒：该培训已结束！'
      } else if (!(this.$moment().add(15, 'days')).isBefore(this.$moment(this.currentTraining.endTime))) {
        this.readOnly = false
        this.dueToRemind = '提醒：该培训将于' + this.currentTraining.endTime + '结束，请抓紧时间学习！'
      } else {
        this.readOnly = false
        this.dueToRemind = ''
      }
      listStudentProjCourseInfoAndStatus({//获得项目和课程状态
        userId: this.userInfo.id,
        trainingId: this.currentTraining.id,
        courseState: this.queryParam.courseState,
        compulsory: this.queryParam.compulsory,
        keyword: this.queryParam.keyword
      }).then((response) => {
        this.projCourseList = response.data.data.list
        this.loading = false
      })
    },
    courseStateComputed: function (ybsCourseState) {
      let courseState = '未学习'
      if (ybsCourseState) {
        switch (ybsCourseState.courseState) {
          case 1:
            courseState = '学习中'
            break
          case 2:
            courseState = '已学完'
            break
        }
      }
      return courseState
    },
    openCourseware(tId, pId, cId) {
      if (!this.readOnly) {
        if (this.currentTraining.creditBingdingTerm == 1) {
          if (this.currentTraining.isBandLearningCard) {
            window.open('/handout'
              + '?uId=' + this.userInfo.id
              + '&tId=' + tId
              + '&pId=' + pId
              + '&cId=' + cId, 'handout_blank')
          } else {
            this.showLearnCardBind = true
          }
        } else {
          window.open('/handout'
            + '?uId=' + this.userInfo.id
            + '&tId=' + tId
            + '&pId=' + pId
            + '&cId=' + cId, 'handout_blank')
        }
      } else {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      }
    },
    openVideoware(childItem, pId) {
      if (!this.readOnly) {
        if (this.currentTraining.creditBingdingTerm == 1) {
          if (this.currentTraining.isBandLearningCard) {
            window.open('/videoPlayer'
              + '?uId=' + this.userInfo.id
              + '&tId=' + this.currentTraining.id
              + '&pId=' + pId
              + '&cId=' + childItem.id, 'video_blank')
          } else {
            this.showLearnCardBind = true
          }
        } else {
          window.open('/videoPlayer'
            + '?uId=' + this.userInfo.id
            + '&tId=' + this.currentTraining.id
            + '&pId=' + pId
            + '&cId=' + childItem.id, 'video_blank')
        }
      } else {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      }
    },
    doApply() {
      this.$confirm('是否确定申请此项目学分?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.applyScoreShow = false
        applyCredit({
          trainingId: this.currentTraining.id,
          userId: this.userInfo.id
        }).then((response) => {
          this.applyScoreShow = true
          if (response.data.status == 1) {
            this.$alert(response.data.info, '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
                this.currentTraining.learnState.trainingStatus = 3
                this.search()
              }
            })
          } else {
            if (response.data.info == '人员信息在本省学分管理平台不存在，请下载继教通APP进行注册'
              || response.data.info == '人员信息与本省学分管理平台不一致，请核实修改') {
              this.$alert('<div style="text-align:center;font-size:13px;">' +
                '<p style="padding-bottom:25px;">' + response.data.info + '</p>' +
                '<img src="https://source.yiboshi.com/public/img/%E7%BB%A7%E6%95%99%E9%80%9AAPP%E4%B8%8B%E8%BD%BD.gif">' +
                '<p style="color:#9A9A9A;font-size:12px;">手机扫一扫下载继教通客户端</p>', '提示', {
                dangerouslyUseHTMLString: true
              })
            } else {
              this.$alert(response.data.info, '提示', {
                confirmButtonText: '确定',
                type: 'error',
                callback: action => {
                }
              })
            }
          }
        })
      }).catch(() => {
        /*this.$message({
         type: 'warning',
         message: '申请失败'
         });*/
      })
    },
    applyScore(trainingId, creditCateggory, creditSetting) {
      if (this.readOnly == true) {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      } else {
        if (!creditCateggory || creditCateggory == '' || creditCateggory == null || creditCateggory == '0' ||
          !creditSetting || creditSetting == '' || creditSetting == null || creditSetting == '0') {
          this.$alert('该项目在您所在地区尚未开展，您暂不能申请学分！', '提示', {
            confirmButtonText: '确定'
          })
        } else {
          //判断考试是否合格
          if (this.currentTraining.creditApplyCondition > 0) {
            getUserTrainingExam({
              userId: this.userInfo.id,
              trainingId: trainingId
            }).then((response) => {
              if (response.data.status == 200) {
                var trainingExam = response.data.data.trainingExam
                var param = ''
                for (var i = 0; i < trainingExam.length; i++) {
                  param += 'examId[]=' + trainingExam[i].examId + '&'
                }
                if (param != '') {
                  param = param.substr(0, param.length - 1)
                  jsonp(process.env.EXAM_API_URL + '/v1/user/' + this.userInfo.id + '/exam/score?' + param
                    , (err, data) => {
                      var exams = data.data
                      for (var k = 0; k < exams.length; k++) {
                        if ((exams[k].score == null && exams[k].passingScore > 0) || exams[k].score < exams[k].passingScore) {
                          this.$alert('结业考试成绩未合格，请点击<a href=\'/MyExam\' target=\'_blank\' style=\'color: #0D9AB5\'>我的考试</a >查看！', '提示', {
                            confirmButtonText: '确定',
                            type: 'error',
                            dangerouslyUseHTMLString: true
                          })
                          return false
                        } else {
                          this.doApply()
                        }
                      }
                    })
                } else {
                  this.doApply()
                }
              }
            })
          } else {
            this.doApply()
          }
          
        }
      }
    },
    haveBandedLearningCard(projectId, courseId, courseFieldID, courseName) {
      if (!this.readOnly) {
        if (this.currentTraining.creditBingdingTerm == 1) {
          if (this.currentTraining.isBandLearningCard) {
            window.open('/usercenter/practice?courseId=' + courseId
              + '&courseFieldID=' + courseFieldID
              + '&trainingId=' + this.currentTraining.id
              + '&projectId=' + projectId
              + '&courseName=' + courseName, 'practice_blank')
          } else {
            this.showLearnCardBind = true
          }
        } else {
          window.open('/usercenter/practice?courseId=' + courseId
            + '&courseFieldID=' + courseFieldID
            + '&trainingId=' + this.currentTraining.id
            + '&projectId=' + projectId
            + '&courseName=' + courseName, 'practice_blank')
        }
      } else {
        this.$message({
          type: 'info',
          message: '该培训已结束！'
        })
      }
    },
    
    validateThinking() {
      getUserThinking({//学员是否有思维训练
        userId: this.userInfo.id,
        trainingId: this.currentTraining.id
      }).then((response) => {
        this.studyTrainingThinking = response.data
      })
    }
    
  },
  mounted() {
    this.search()
    this.validateThinking()
  },
  watch: {
    currentTraining: function (newValue, oldValue) {
      this.queryParam = {
        courseState: '',
        compulsory: '',
        keyword: ''
      }
      this.search()
      this.validateThinking()
    }
  }
}
</script>

<style scoped>
.overflow {
  overflow: hidden; /*超出部分隐藏*/
  max-width: 375px;
  white-space: nowrap;
  /*文本溢出用"..."表示*/
  -o-text-overflow: ellipsis; /*适用opera*/
  text-overflow: ellipsis; /*适用IE*/
}

table.collapse tr td {
  padding: 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/NotCmePage.vue